import * as Analytics from 'analytics/Analytics';
import {makeAnalyticsEventId} from 'analytics/Analytics';
import {ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';
import {WORKFLOWS_ANALYTICS_ACTIONS} from 'constants/analytics-products';
import {CREATE_PROCESS_MODAL_TYPE} from 'constants/analytics-products/WorkflowAnalyticsConstants';
import {ActionOrigin, COMMON_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {SchemaFieldSelectorsDict} from 'notebook/structured-tables/hooks/useSelectorsById';
import {StructuredTable, StructuredTableAdapter} from 'notebook/structured-tables/StructuredTableConstants';
import {EvaluatedCell} from 'notebook/tables/excess/Evaluator';
import CreateProcessModal, {
  TableOrFormRenderOptionsToAnalyticsType,
} from 'processes/modals/CreateProcessModal';
import {getInitialCreateTaskModalViewPreference} from 'processes/modals/CreateProcessModalViewPreference';
import SelectTaskColumnMappingsModal, {
  SelectTaskColumnMappingsModalCreationType,
  TaskColumnMappingInfo,
} from 'processes/modals/SelectTaskColumnMappingsModal';
import {ProcessTableLocation} from 'processes/ProcessConstants';
import legacyRunModal from 'ui-library/legacyRunModal';

import {ProcessTaskSchema} from '../create-process-button/CreateProcessButton';
import createEmptyTaskTableFromSchema from '../createEmptyTaskTableFromSchema';

export async function handleSelectSchema(
  sourceColumns: Array<TaskColumnMappingInfo>,
  taskSchema: ProcessTaskSchema,
  selectorsById: SchemaFieldSelectorsDict,
  sourceType: string,
  actionOrigin: ActionOrigin,
  onClickTracking?: () => void,
  structuredTableAdapter?: StructuredTableAdapter<unknown, unknown>,
  structuredTable?: StructuredTable<unknown, unknown>,
  computedTable?: Array<Array<EvaluatedCell>> | null
): Promise<void> {
  const analyticsEventGroupId = makeAnalyticsEventId();
  Analytics.trackEventWithModule(COMMON_ANALYTICS_ACTIONS.OPENED_MODAL, ANALYTICS_MODULE.WORKFLOWS, {
    event_group_id: analyticsEventGroupId,
    action_origin: actionOrigin,
    default_task_creation_view:
      TableOrFormRenderOptionsToAnalyticsType[getInitialCreateTaskModalViewPreference(taskSchema.id)[0]],
    modal_type: CREATE_PROCESS_MODAL_TYPE,
  });
  const taskTable = createEmptyTaskTableFromSchema({
    name: taskSchema.name,
    taskSchema,
    tableLocation: ProcessTableLocation.CREATE_MODAL,
    locked: false,
    selectorsById,
  });
  if (sourceColumns.length === 0) {
    Analytics.trackEventWithModule(
      WORKFLOWS_ANALYTICS_ACTIONS.FAILED_COLUMN_MAPPING_TO_TASK_TABLE,
      ANALYTICS_MODULE.WORKFLOWS,
      {
        event_group_id: analyticsEventGroupId,
        action_origin: actionOrigin,
        modal_type: CREATE_PROCESS_MODAL_TYPE,
      }
    );
    onClickTracking?.();
    legacyRunModal(CreateProcessModal, {
      processTaskSchemaId: taskSchema.id,
      processTaskSchemaName: taskSchema.name,
      initialFolderId: null,
      taskGroupInstructions: taskSchema.taskGroupInstructions,
      taskTableWithPropagatedContent: taskTable,
      sourceType,
      analyticsEventGroupId,
    });
  } else {
    const result = await legacyRunModal(SelectTaskColumnMappingsModal, {
      sourceColumns,
      taskSchema,
      taskTable,
      selectorsById,
      creationType: SelectTaskColumnMappingsModalCreationType.PROCESS,
      structuredTableAdapter,
      structuredTable,
      computedTable,
    });
    if (result != null && result.shouldRunCreateModal) {
      onClickTracking?.();
      legacyRunModal(CreateProcessModal, {
        processTaskSchemaId: taskSchema.id,
        processTaskSchemaName: taskSchema.name,
        initialFolderId: null,
        taskGroupInstructions: taskSchema.taskGroupInstructions,
        taskTableWithPropagatedContent: result.taskTable ?? taskTable,
        sourceType,
        analyticsEventGroupId,
      });
    }
  }
}
